module.exports = __webpack_public_path__ + "static/media/02d.2d1d1c8a.png";